import emailValidator from './emailValidator';
import time from './time';
import url from './url';
import SmartInt from './SmartInt';
import t from 'tcomb-form';


export default {
    email: emailValidator,
    time: time,
    SmartInt: SmartInt,
    minLengthStr: (minLength) => t.subtype(t.Str, (n) => n && n.length >= minLength || null),
    positiveInt: t.subtype(t.Num, (x) => x > 0),
    professionHourlyRate: t.subtype(t.Num, (x) => x >= 1 && x <= 50),
    url: url
};



/** WEBPACK FOOTER **
 ** ./app/src/forms/validators/index.js
 **/